import React, {useEffect, useState} from 'react';
import {useRegistrationSteps} from "../../utilities/context/registration-steps/registration-steps-context";
import useAuthCalls from "../../utilities/custom-hooks/auth-calls";
import {doPostUser} from "../../logic/users";
import WaitingForConfirmationMessage from "../Registration/WaitingForConfirmationMessage";
import Form from "../Registration/Form";
import Loading from "../UI/Loading";
import ConfirmedEmailMessage from "../Registration/ConfirmedEmailMessage";

const Step1 = () => {

    const {call} = useAuthCalls();
    const {emailVerified, setRegistrationError, registrationError} = useRegistrationSteps();

    const [registrationSent, setRegistrationSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [registrationEmail, setRegistrationEmail] = useState(null);

    const handleRegistration = async (fields) => {
        setRegistrationError(null);
        setLoading(true);
        let params = new URLSearchParams();
        params.append('name', fields.name);
        params.append('password', fields.password);
        params.append('email', fields.email);
        params.append('mobile', fields.mobile);
        params.append('fiscal_code', fields.fiscal_code);
        params.append('profession', fields.profession);

        await call(
            () => doPostUser(params),
            (res) => {
                setRegistrationSent(true);
                localStorage.setItem('registration_sent', "true");
                localStorage.setItem('email_to_verify', fields.email);
                setRegistrationEmail(fields.email);
            },
            (error) => {
                setRegistrationError(error.message);
            }
        )

        setLoading(false);
    }

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            const urlParams = new URLSearchParams(window.location.search);
            let token = urlParams.get('token');
            let sent = localStorage.getItem('registration_sent');
            if (token || sent) {
                setRegistrationSent(true);
            }
            let emailToVerify = localStorage.getItem('email_to_verify');
            if(emailToVerify) {
                setRegistrationEmail(emailToVerify);
            }
            setLoading(false);
        }

        load();
    }, []);

    return (
        <div>
            {loading ?
                <Loading/>
                :
                registrationSent
                    ? emailVerified
                        ? <ConfirmedEmailMessage/>
                        : <WaitingForConfirmationMessage email={registrationEmail}/>
                    :
                        <Form onSubmit={handleRegistration} errorMessage={registrationError} className="w-full"/>
            }
        </div>
    );
};

export default Step1;